<template>
  <el-form ref="formValidate"
           :model="params"
           label-width="100px"
           :rules="rules">
    <el-form-item prop="parentId"
                  :label="$t('announcement.content')"
                  v-show="!isUpdate">
      <el-input v-model="parent.name"
                style="width:200px;"
                disabled></el-input>
    </el-form-item>
    <el-form-item prop="name"
                  :label="$t('announcement.content')">
      <el-input type="text"
                v-model="params.name"
                :placeholder="$t('common.nameRequire')"
                style="width:200px;"> </el-input>
    </el-form-item>
    <el-form-item prop="status"
                  :label="$t('announcement.content')">
      <zk-dictionary-select type="status"
                            v-model="params.status"
                            style="width:200px;"
                            :placeholder="$t('common.select')">
      </zk-dictionary-select>
    </el-form-item>
    <el-form-item prop="value"
                  :label="$t('announcement.content')">
      <el-input type="text"
                v-model="params.remark"
                :placeholder="$t('announcement.content')"
                style="width:200px;"> </el-input>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  name: 'zk-message-ann-save-or-update',
  props: ['form', 'isUpdate'],
  data () {
    let checkStatus = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('common.statusRequire')))
      } else {
        callback()
      }
    }
    let rules = {
      name: [{ required: true, message: this.$t('common.nameRequire'), trigger: 'blur' }],
      status: [{ required: true, validator: checkStatus, trigger: 'blur' }]
    }
    return {
      rules,
      params: {},
      parent: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/messageAnnSaveOrUpdate/src/main.vue